import React from 'react'
import EditIcon from './Icons/EditIcon'

const EditButton = ({ onClick }) => {
  return (
    <button
      className="btn btn-circle btn-ghost btn-sm"
      onClick={(e) => {
        e.stopPropagation()
        onClick()
      }}
    >
      <EditIcon />
    </button>
  )
}

export default EditButton
